import { connectedStore } from '../../store';

const isPathAvailable = (path) => {
  const store = connectedStore.get();
  const state = store.getState();
  const { pages } = state.ws.site.meta;

  return !pages.some((page) => page.path === path);
};

export default isPathAvailable;
